import { render, staticRenderFns } from "./WidgetGreen.vue?vue&type=template&id=7c372a4e"
import script from "./WidgetGreen.vue?vue&type=script&lang=js"
export * from "./WidgetGreen.vue?vue&type=script&lang=js"
import style0 from "./WidgetGreen.vue?vue&type=style&index=0&id=7c372a4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports